import Image from '@/common/image';
import { ReactComponent as Facebook } from '../../images/svgs/facebook.svg';
import { ReactComponent as Instagram } from '../../images/svgs/instagram.svg';
import { navLinks } from '../../constants';
import { Link } from 'gatsby';

export default function Footer() {
    return (
        <div className="mt-auto bg-footerMaroon py-[64px] text-white ">
            <div className="flex justify-center">
                <Image
                    className="w-[250px] cursor-pointer"
                    filename="zapata-logo.png"
                    alt="footer-logo"
                />
            </div>
            <div className="grid gap-4 grid-cols-3 sm:grid-cols-5 lg:flex text-center justify-center py-8 max-w-[950px] mx-auto">
                {navLinks.map(({ label, link }, i) => (
                    <Link to={link} key={i} className="cursor-pointer whitespace-nowrap mx-4">
                        {label}
                    </Link>
                ))}
            </div>
            <div className="flex justify-center">
                <Link to="https://www.facebook.com/pages/Zapata-Dental-LLC/168050813208817?ref=br_tf">
                    <div className="pr-8">
                        <Facebook className="cursor-pointer" />
                    </div>
                </Link>
                <Link to="https://www.instagram.com/zapatadental/">
                    <Instagram className="cursor-pointer" />
                </Link>
            </div>
            <div className="text-center pt-6">© 2022 Zapata Dental | All Right Reserved</div>
        </div>
    );
}
